import { render } from "./SimpleWrapper.vue?vue&type=template&id=08640c10"
const script = {}

import exportComponent from "/ws/7d23fcbcf8cf42679552365d2ccff9a6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__